import { Security } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/** Журнал аудита клиники (БЕЗ-12, матрица 2.2: OWNER и MED_DIRECTOR — чтение). */
export const section = defineSection({
  id: 'audit.log',
  area: 'clinic',
  path: 'audit',
  roles: ['OWNER', 'MED_DIRECTOR'],
  icon: Security,
  titleKey: 'audit:title',
  navGroup: 'manage',
  order: 26,
  tabGroup: 'clinic',
  load: () => import('./AuditLogPage'),
});
